module.exports = __webpack_public_path__ + "img/icone-disp.0c22ecec.svg";